/*
|--------------------------------------------------------------------------
| Views: Article Image List
|--------------------------------------------------------------------------
*/

/**
 * Article Image List
 * @namespace
 */
__gh__webApp.views.articleImagelist = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){
		var views = __gh__webApp.views;
		views.article.callbacks(bucket);
	},
	
	
	"prepItemData": function(items){
		var commonJS		= __gh__webApp.common,
			item 			= items[0],
			relatedItems 	= item.relatedContent.items,
			firstGallery	= true;

		//Related types array to check for related icons in view
		for(var i=0; i<relatedItems.length; i++){
			var relatedItem = relatedItems[i],
				type 		= relatedItem.type;


			if(relatedItem.items.length && type=="gallery" && firstGallery){
				//Add gallery to imageList node
				items[0].relatedContent.imageList = relatedItem.items;
				
				//Remove gallery from related items so it doesn't show as a gallery slider
				relatedItems.splice(i,1)
				
				//Update related items
				items[0].relatedContent.items = relatedItems;
				
				firstGallery = false;
				break;
			}
		}

		return items;
	},

	"getSubView": function(bucket){
		var items										= bucket.items.main;
		
		bucket.items.main								= this.prepItemData(items);
		bucket.view.name 								= "buckets/articleImagelist/default";
		bucket.view.staticName 							= "articleImagelist";
		return bucket;

	}
};	
	